import {IconButton} from '@mui/material';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import React from 'react';

type AddRowBtnProps = {
  onClick: () => void
}

const AddRowBtn = ({onClick}: AddRowBtnProps) => (
  <IconButton onClick={onClick} size={'small'}>
    <PlaylistAddIcon />
  </IconButton>
);

export default AddRowBtn;
